class NumProduct extends HTMLElement {
  static get observedAttributes() {
    return ['open-modal-size'];
  }

  constructor() {
    super();
    this._openedSizeModal = false;
  }

  connectedCallback() {
    this.btnSize = this.querySelector('#Btn-InfoSize');
    this.modalSize = this.querySelector('#Modal-InfoSize');
    this._attachEventListeners();
    this._updateModalState();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open-modal-size') {
      this._openedSizeModal = newValue === 'true';
      this._updateModalState();
    }
  }

  _openModal(name) {
    this.setAttribute(`open-modal-${name}`, 'true');
  }

  _closeModal(name) {
    this.setAttribute(`open-modal-${name}`, 'false');
  }

  _attachEventListeners() {
    if (this.btnSize) {
      this.btnSize.addEventListener('click', this._openModal.bind(this, 'size'));
    }
    if (this._modalSize) {
      this._modalSize.addEventListener('onClose', this._closeModal.bind(this, 'size'));
    }
  }

  _updateModalState() {
    console.log('updateModalState');
    if (this._openedSizeModal && this.modalSize) {
      console.log('updateModalState');
      this.modalSize.open(this.btnSize);
    }
  }
}

customElements.define('num-product', NumProduct);
